export default __webpack_public_path__ + "static/media/assembly_2.18c6fb6b.webp";